import { IconButton, ListItemButton, Menu, SvgIcon } from '@mui/material'
import { IconDotsVertical } from '@tabler/icons-react'
import { useState } from 'react'

export const OrderListMenu = ({
  onCreateVisitor,
  disabled,
}: {
  onCreateVisitor: () => void
  disabled: boolean
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <SvgIcon>
          <IconDotsVertical />
        </SvgIcon>
      </IconButton>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        <ListItemButton
          onClick={() => {
            onCreateVisitor()
            setAnchorEl(null)
          }}
          disabled={disabled}
        >
          Create Visitor
        </ListItemButton>
      </Menu>
    </>
  )
}
